import { render, staticRenderFns } from "./app-product-card.vue?vue&type=template&id=33ee1978&scoped=true&"
import script from "./app-product-card.vue?vue&type=script&lang=js&"
export * from "./app-product-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee1978",
  null
  
)

export default component.exports